import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { getAuthToken, clearAuthState } from "./utils/authUtils";

const GRAPHQL_ENDPOINT =
  "https://g4hngea4jff63nikf5afadahlu.appsync-api.us-east-1.amazonaws.com/graphql";

// Create HTTP link
const httpLink = createHttpLink({
  uri: GRAPHQL_ENDPOINT,
});

// Create auth link that adds JWT token to headers
const authLink = setContext((_, { headers }) => {
  // Get the JWT token from localStorage
  const token = getAuthToken();
  
  // Debug logging
  if (token) {
    console.log("apolloClient - Adding JWT token to request headers");
  } else {
    console.warn("apolloClient - No JWT token found in localStorage");
  }
  
  // Return the headers to the context so httpLink can read them
  // For AWS AppSync with Cognito, use token without "Bearer" prefix
  return {
    headers: {
      ...headers,
      // AppSync Cognito auth expects: Authorization: <token> (without Bearer)
      ...(token ? { Authorization: token } : {}),
    },
  };
});

// Create error link to handle 401 Unauthorized (expired tokens)
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, extensions }) => {
      if (extensions?.errorType === "UnauthorizedException" || message.includes("Unauthorized")) {
        console.error("apolloClient - Unauthorized error detected, token may be expired");
        clearAuthState();
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    });
  }

  if (networkError?.statusCode === 401) {
    console.error("apolloClient - 401 Unauthorized network error, token may be expired");
    clearAuthState();
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
  }
});

export const client = new ApolloClient({
  link: errorLink.concat(authLink).concat(httpLink),
  cache: new InMemoryCache(),
});
